// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setDate as fn } from "../setDate.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setDate = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setDate;
